<template>
	<v-container>
		<v-row>
			<v-col
				cols="12"
				sm="4"
			>
				<v-text-field
					label="Folio de Solicitud"
					v-model="idSolicitudCreada"
					readonly
				></v-text-field>
			</v-col>
			<v-col
				cols="12"
				sm="4"
			>
				<v-text-field
					label="Fecha de solicitud"
					v-model="fechaSolicitudCreada"
					readonly
					prepend-icon="mdi-calendar"
				></v-text-field>
			</v-col>
			<v-col
				cols="12"
				sm="4"
			>
				<v-combobox
					label="Módulo o Programa"
					v-model="moduloPrograma"
					:items="moduloProgramaLista"
					item-text="nombre"
					item-value="idModulo"
					:rules="ComboRules"					
				></v-combobox>
			</v-col>
		</v-row>

		<v-row>
			<v-col
				cols="12"
				sm="6"
			>
				<v-textarea
					label="Narración de hechos"
					v-model="narracion"
					rows="5"
					background-color="teal lighten-5" 
					color="teal teal-darken-4" 
					prepend-icon="mdi-comment"
				>
				</v-textarea>
			</v-col>
			<v-col
				cols="12"
				sm="6"
			>
				<v-textarea
					label="Observaciones"
					v-model="observaciones"
					rows="5"
					background-color="teal lighten-5" 
					color="teal teal-darken-4" 
					prepend-icon="mdi-comment"
				>
				</v-textarea>
			</v-col>
		</v-row>
		<!--
		<v-row>
			<v-col
				cols="12"
				sm="6"
			>
				<v-switch
					v-model="contactoRealizado"
					label="Contacto Realizado"
					color="orange orange-darken-4"
				></v-switch>
			</v-col>
			<v-col
				cols="12"
				sm="6"
			>
				<v-switch
					v-model="asistioPrimerSesion"
					label="Asistió a primer sesión"
					color="orange orange-darken-4"
				></v-switch>
			</v-col>
		</v-row>
		-->
		<v-row>
			<v-col>
				<!--
				<v-combobox
					label="Terapeuta Asignado"
					v-model="terapeuta"
					:items="terapeutaLista"
					item-text="nombre"
					item-value="idTerapeuta"
				></v-combobox>
				-->
				<v-combobox
					label="Status de la Intervencion"
					v-model="statusIntervencion"
					:items="statusIntervencionLista"
					item-text="descripcion"
					item-value="idStatus"
				></v-combobox>
				<v-combobox
					label="Motivo de la Consulta"
					v-model="motivoConsulta"
					:items="motivoConsultaLista"
					item-text="descripcion"
					item-value="idMotivo"
				></v-combobox>
			</v-col>
		</v-row>
		<v-row>
			<v-col
				cols="12"
				sm="6"
			>
				<v-textarea
					label="Seguimiento"
					v-model="seguimiento"
					rows="5"
					background-color="teal lighten-5"
					color="teal teal-darken-4" 
					prepend-icon="mdi-comment"
				>
				</v-textarea>
			</v-col>
			<v-col
				cols="12"
				sm="6"
			>
				<v-textarea
					label="Anotaciones"
					v-model="anotaciones"
					rows="5"
					background-color="teal lighten-5" 
					color="teal teal-darken-4" 
					prepend-icon="mdi-comment"
				>
				</v-textarea>
			</v-col>
		</v-row>
		<v-btn 
			color="info"
			@click="actualizaSolicitud"
		>
			Guardar Datos</v-btn>
	</v-container>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi'
export default {
	data() {
		return {
			respuesta: '',
			folioSolicitud: 0,
			fechaSolicitud: '',
			idModuloPrograma: 0,
			moduloPrograma: '',
			moduloProgramaLista: [],
			narracion: '',
			observaciones: '',
			contactoRealizado: false,
			asistioPrimerSesion: false,
			idTerapeuta: 0,
			terapeuta: '',
			terapeutaLista: [],
			idStatusIntervencion: 0,
			statusIntervencion: '',
			statusIntervencionLista: [],
			idMotivoConsulta: 0,
			motivoConsulta: '',
			motivoConsultaLista: [],
			seguimiento: '',
			anotaciones: '',
			ComboRules: [
				value => !!value || "Debe especificarse una opción"
			],
		}
	},
	created() {
		ServiciosApi.catalogosTodos(2)
			.then(response => {
				this.respuesta = response.data
				this.moduloProgramaLista = this.respuesta.datos.moduloPrograma
				this.statusIntervencionLista = this.respuesta.datos.statusIntervencion
				this.terapeutaLista = this.respuesta.datos.terapeuta
				this.motivoConsultaLista = this.respuesta.datos.motivoConsulta
			})
			.catch(error => {
				console.log("Hubieron errores", error.response)
			})
	},
	props:{
		idSolicitudCreada: Number,
		fechaSolicitudCreada: String 
	},
	methods: {
		actualizaSolicitud() {
			console.log("entramos al actualizaSolicitud")
			let solicitud =  {
				idSolicitud: this.idSolicitudCreada,
				idModuloPrograma: this.moduloPrograma.idModulo,
				narracionHechos: this.narracion,
				observaciones: this.observaciones,
				//contactoRealizado: this.contactoRealizado,
				//asistioPrimerSesion: this.asistioPrimerSesion ? 'Si' : 'No aplica',
				anotaciones: this.anotaciones,
				//idTerapeuta: this.terapeuta.idTerapeuta,
				idStatusIntervencion: this.statusIntervencion.idStatus,
				idMotivoConsulta: this.motivoConsulta.idMotivo,
				seguimiento: this.seguimiento
			}
			console.log("Solicitud: " + solicitud)
			ServiciosApi.actualizaSolicitud(solicitud)
				.then(response => {
					this.respuesta = response.data
					this.$router.push("/")
				})
				.catch(error => {
					console.log("Hubieron errores", error.response)
				})
		}
	}
}
</script>
